import React from 'react'
let PropTypes = React.PropTypes
import api from '../../../apiClient/v1.js'
// COMPONENTES
import { TablaInventarios } from './TablaInventarios.jsx'

export class ServiciosRealizados extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mes: this.props.meses[0]['value'],
            inventarios: []
        }
        this.buscarInventarios = ()=>{
            let mes = this.state.mes
            api.facturacion(this.props.cliente).getServiciosSalcobrand(mes)
                .then(inventarios=>{
                    this.setState({inventarios})
                })
                .catch(meh=>{})
        }
        this.onSelectMesChanged = (evt)=>{
            this.setState({
                mes: evt.target.value
            }, ()=>{
                this.buscarInventarios()
            })
        }
    }
    componentWillMount(){
        this.buscarInventarios()
    }
    render() {
        return (
            <div className={'container-fluid'}>
                <div className={'row'}>
                    <div className={'col-sm-2 form-group '}>
                        <label className="control-label" htmlFor="selectMes">Mes</label>
                        <select className="form-control"  name="selectMes"
                                ref={ref=>this.inputMes=ref}
                                value={this.state.mes}
                                onChange={this.onSelectMesChanged.bind(this)}>
                            >
                            {this.props.meses.map((mes, index)=>{
                                return <option key={index} value={mes['value']}>{`${mes['text']}`}</option>
                            })}
                        </select>
                    </div>
                    <BotonExcel
                        mes={this.state.mes}
                        cliente={this.props.cliente}
                    />
                </div>
                <TablaInventarios
                    inventarios ={this.state.inventarios}
                />
            </div>
        )
    }
}
ServiciosRealizados.propTypes = {
    meses: PropTypes.arrayOf(PropTypes.object),
    cliente: PropTypes.number
    // Permisos
}
const BotonExcel = ({mes, cliente})=>
    <a className={'btn btn-md btn-success pull-right'}
       href={`/api/consolidado/mes/${mes}/${cliente}`}>
        Consolidado
    </a>
        
   


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/serviciosRealizados/ServiciosRealizados.jsx